<template>
  <section class="homepage-ctas">
    <div :class="{ row: isDesktop }">
      <div class="cta-grid">
        <template v-for="(item, index) in ctas" :key="index">
          <div
            class="cta"
            :class="{
              sqr: item.meta_data_object.size === 'square',
              rect: item.meta_data_object.size === 'rectangle',
            }"
          >
            <nuxt-link :to="item.url" class="cta-url">
              <NuxtImg
                class="cta-image"
                :src="
                  !isDesktop && item.mobile_image_url
                    ? item.mobile_image_url + '?auto=format,compress&fm=webp'
                    : item.image_url + '?auto=format,compress&fm=webp'
                "
                :alt="item.image_url_alt_text || item.name || 'CTA image'"
                :modifiers="{ format: 'webp' }" 
              />
            <h3 class="cta-overlay-text" v-html="item.name"></h3>
            </nuxt-link>

          </div>
        </template>
      </div>
    </div>
  </section>
</template>


<script setup>
import { ref, computed, watch } from "vue";
import { useMainStore } from "~/store/index";

const store = useMainStore();
const { isMobile, isDesktop } = useMobileChecker();

// PROPS
const props = defineProps(["featuredServices", "galleryData"]);

const mobileGallery = props.galleryData?.find(
  (gallery) => gallery.name === "Homepage CTA Mobile"
);

const mobileGalleryItems = mobileGallery?.gallery_items || [];

const ctas = _filter(props.featuredServices, (el) => {
  try {
    if (typeof el.meta_data === "string") {
      const cleanedMeta = el.meta_data.replace(
        /([{,]\s*)(\w+)\s*:/g,
        '$1"$2":'
      );
      el.meta_data_object = JSON.parse(cleanedMeta);
    } else {
      el.meta_data_object = {};
    }
  } catch (e) {
    console.warn("Invalid meta_data:", el.meta_data, e);
    el.meta_data_object = {};
  }

  // Match mobile image from gallery if available
  const matchedMobileImage = mobileGalleryItems.find(
    (item) => item.name === el.name
  );

  if (matchedMobileImage) {
    el.mobile_image_url = matchedMobileImage.image_url;
  }

  return !el.is_featured_on_home_page;
});
</script>

<style lang="scss" scoped>
.homepage-ctas {
  margin: 30px 0;

  .cta-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 50px;
    row-gap: 50px;

    @media only screen and (max-width: 1024px) {
      grid-template-columns: 1fr;
      column-gap: 0px;
      row-gap: 50px;
      padding: 0 30px;
    }

    @media only screen and (max-width: 580px) {
      padding: 0 0px;
      row-gap: 20px;
    }
  }

  .cta {
    position: relative;

    &.rect {
      grid-column: span 2;

      @media only screen and (max-width: 1024px) {
        grid-column: span 1 !important;

        img {
          height: inherit;
        }
      }
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .cta-overlay-text {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $white;
      background-color: rgba(0, 0, 0, 0.25);
      padding: 10px 30px;
      text-align: center;
      box-sizing: border-box;
      text-transform: uppercase;
      font-size: 33px !important;
      font-weight: 300 !important;
      letter-spacing: 2px !important;
      text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.5) !important;
      font-family: $font_poppin !important;
      line-height: 38px !important;
      pointer-events: none;
    }
    
    &:hover .cta-overlay-text {
      background-color: rgba(0, 0, 0, 0.15);
    }
  }

  @media only screen and (max-width: 580px) {
    margin: 0 0 30px;
  }
}
</style>

